<div (mouseenter)="hoverExpand()" (mouseleave)="hoverCollapse()">
    <ng-content></ng-content>
</div>
